import { apiClient, type ApiResponse } from '@/lib/apiClient';
import type { QueryOptions } from '@/lib/reactQuery';
import type { DateString } from '@/types/api';
import type { Center } from '@/types/center';
import type { Guardian } from '@/types/guardian';
import type { Student } from '@/types/student';
import { useQuery } from '@tanstack/react-query';

interface GetStartupConfigResponseData {
  data: {
    guardian: Guardian;
    students: Student[];
    center: Center;
    creditCardExpiriesAt?: DateString;
    failedPayment: boolean;
    overdueInvoice: boolean;
    isDemoEligible: boolean;
    ketchToken?: string;
  };
}

type GetStartupConfigResponse = ApiResponse<GetStartupConfigResponseData>;

export const getStartupConfig = async () => {
  const response = await apiClient.get<GetStartupConfigResponse>('/v1/startup-config');
  return response.data?.data;
};

export const useStartupConfig = (options?: QueryOptions<GetStartupConfigResponseData>) => {
  return useQuery({
    queryKey: ['startup-config'],
    queryFn: getStartupConfig,
    ...options,
  });
};
